export const ACTION_OPTIONS = [
  { id: 'artifact-detect', name: 'Artifact Detect' },
  { id: 'eye', name: 'Eye Movement' },
  { id: 'bandpower', name: 'Bandpower' },
  { id: 'blink', name: 'Blink' },
  { id: 'metrics', name: 'Metrics' },
  { id: 'brow-down', name: 'Brow Down' },
  { id: 'brow-up', name: 'Brow Up' },
  { id: 'wink-left', name: 'Wink Left' },
  { id: 'wink-right', name: 'Wink Right' },
  { id: 'concentration', name: 'Concentration' },
  { id: 'percent-concentration', name: 'Percent Concentration' },
];

export const BOOLEAN = 'boolean';
export const VALUE_TYPE_OPTIONS = [
  { id: BOOLEAN, name: 'Boolean' },
  { id: 'value', name: 'Value' },
  { id: 'json', name: 'JSON' },
];

export const VALUE_OPTIONS = [
  { id: 'true', name: 'True' },
  { id: 'false', name: 'False' },
];

export const MODE_OPTIONS = [
  { id: 'GET', name: 'GET' },
  { id: 'POST', name: 'POST' },
];

export const CONTEXTS = 'contexts';
